export default __webpack_public_path__ + "locales/lo-LA/PeopleTranslations.json?hash=41ea76660ac30eeeaf63b63a65f3794a";